import { CustomErrorType, UNKNOWN_ERROR, RESERVED_ERROR_CODE, HttpErrorType, JSON_PARSING_FAILED_BLOB_ERROR } from '../constants.mjs';
import { FlexHttpError } from '../models/flexHttpError.mjs';
import { isAxiosError } from './axiosError.mjs';
import { isRouteChangeCanceledError, isAccessTokenTypeError } from './customError.mjs';
import { toFlexHttpError } from './flexHttpError.mjs';

function transformBlobToStringSynchronously(blob) {
  const url = URL.createObjectURL(blob);
  const xmlHttpRequest = new XMLHttpRequest();
  xmlHttpRequest.open("GET", url, false);
  xmlHttpRequest.send();
  URL.revokeObjectURL(url);
  return xmlHttpRequest.responseText;
}
function getHttpErrorData(data = {
  code: UNKNOWN_ERROR
}) {
  if (globalThis.Blob && data instanceof globalThis.Blob) {
    const stringifiedData = transformBlobToStringSynchronously(data);
    try {
      return toFlexHttpError(JSON.parse(stringifiedData));
    } catch {
      return new FlexHttpError(
        JSON_PARSING_FAILED_BLOB_ERROR,
        "Blob parsing failed",
        900
      );
    }
  }
  return toFlexHttpError(data);
}
function decideError(error) {
  if (isRouteChangeCanceledError(error)) {
    return [CustomErrorType.RouteChangeCanceled, void 0];
  }
  if (isAccessTokenTypeError(error)) {
    return [CustomErrorType.AccessTokenTypeError, void 0];
  }
  if (!isAxiosError(error)) {
    return [CustomErrorType.Unknown, void 0];
  }
  const { response } = error;
  const { status = UNKNOWN_ERROR, data = {} } = response ?? {};
  const { code, message, trace } = getHttpErrorData(data);
  const httpError = new FlexHttpError(
    code,
    message,
    status,
    "decide-error",
    trace
  );
  if (status === 401 && code === RESERVED_ERROR_CODE.UNAUTHORIZED_FFA) {
    return [HttpErrorType.FfaUnauthorized, httpError];
  } else if (status === 401 && code === RESERVED_ERROR_CODE.INVALID_ACCOUNT) {
    return [HttpErrorType.InvalidAccount, httpError];
  } else if (status === 401) {
    return [HttpErrorType.Unauthorized, httpError];
  } else if (status === 403 && code === RESERVED_ERROR_CODE.IP_ALL_FEATURES) {
    return [HttpErrorType.IpBlockedAllFeature, httpError];
  } else if (status === 403 && code === RESERVED_ERROR_CODE.IP_SPECIFIC_FEATURE) {
    return [HttpErrorType.IpBlockedRoles, httpError];
  } else if (status === 403 && (code === RESERVED_ERROR_CODE.FORBIDDEN || code === RESERVED_ERROR_CODE.FORBIDDEN_LEGACY)) {
    return [HttpErrorType.Forbidden, httpError];
  } else if (status >= 500 && status < 600) {
    return [CustomErrorType.ServerError, httpError];
  }
  return [CustomErrorType.Unknown, httpError];
}

export { decideError };
//# sourceMappingURL=apiError.mjs.map
